const direction = {
    asc: '0',
    desc: '1',
}

export default direction